import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
import { offerBullets } from '../data/content';
export function Offer() {
  return <section id="offer" className="scroll-mt-2 bg-navy px-3 py-4 sm:px-6" data-id="element-107" data-mp="17ws2s9xeyodg">
      <div className="mx-auto max-w-xl text-center" data-id="element-108" data-mp="1mmqz075erpqa">
        <p className="inline-block rounded-full bg-magenta px-3 py-0.5 font-heading text-[0.65rem] font-extrabold uppercase tracking-widest text-white sm:text-xs" data-id="element-109" data-mp="1hnw80hxaeuv3">
          Special launch offer
        </p>
        <h2 className="mt-1.5 text-lg font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-110" data-mp="p0jvl0kuc3fi">
          🔬 HISTOLOGY &amp; PATHOLOGY VISUAL ATLAS™
        </h2>
        <p className="mt-0.5 font-heading text-xs font-bold uppercase tracking-wide text-electric sm:text-sm" data-id="element-111" data-mp="yxxydxductpc">
          The Complete Visual Study System for Histology &amp; Pathology Students
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[260px] sm:max-w-[320px]" target="checkout" data-id="element-112" data-mp="2ad3d5zr8yipb" />

        <div className="mt-2 rounded-md border-[3px] border-electric bg-white px-3 py-2.5 text-left" data-id="element-113" data-mp="pk7eriduof7v">
          <p className="text-center font-heading text-xs font-extrabold uppercase tracking-wide text-navy sm:text-sm" data-id="element-114" data-mp="ujbqogs5sr1w">
            Complete 6-in-1 System
          </p>
          <ul className="mt-1.5 grid gap-1 sm:grid-cols-2" data-id="element-115" data-mp="zj6hylfujinh">
            {offerBullets.map(b => <li key={b} className="flex items-start gap-1.5" data-id="element-116" data-mp="13hw0stjnlsei">
                <span className="text-xs leading-tight" aria-hidden="true" data-id="element-117" data-mp="6usf9sdtby5l">
                  ✅
                </span>
                <span className="text-xs leading-tight sm:text-sm" data-id="element-118" data-mp="btc0fqkl15ww">{b}</span>
              </li>)}
          </ul>
          <p className="mt-2 text-center font-heading text-sm font-extrabold uppercase leading-tight text-navy sm:text-base" data-id="element-119" data-mp="fskvqzv9tbuk">
            🔥 GET HISTOLOGY &amp; PATHOLOGY VISUAL ATLAS™ TODAY —{' '}
            <span className="text-magenta" data-id="element-120" data-mp="3k6t4g7rxcz8a">$27 USD</span>
          </p>
          <div className="mt-1.5" data-id="element-121" data-mp="3o8o3t6qap2jf">
            <CTAButton label="⚡ GET INSTANT ACCESS" sub="Immediate Digital Access" target="checkout" tone="magenta" data-id="element-122" data-mp="3o7uxg6v90f1t" />
          </div>
          <p className="mt-2 text-center text-[0.7rem] font-bold uppercase tracking-wide text-navy sm:text-xs" data-id="element-123" data-mp="155k7v0vc3nve">
            🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}